const INDUSTRY_OPTIONS = [
  // DNFI industries
  { value: 'accounting_firms', label: 'Accounting Firms', dnfi: true },
  { value: 'audit_firms', label: 'Audit Firms', dnfi: true },
  { value: 'car_dealers', label: 'Car Dealers', dnfi: true },
  {
    value: 'casinos_pool_betting_lottery_businesses',
    label: 'Casinos, Pool Betting & Lottery Businesses',
    dnfi: true
  },
  { value: 'clearing_forwarding_companies', label: 'Clearing & Forwarding Companies', dnfi: true },
  { value: 'construction_companies', label: 'Construction Companies', dnfi: true },
  { value: 'consulting_companies', label: 'Consulting Companies', dnfi: true },
  { value: 'dealers_in_jewelery', label: 'Dealers In Jewelery', dnfi: true },
  { value: 'dealers_in_luxury_goods', label: 'Dealers In Luxury Goods', dnfi: true },
  {
    value: 'dealers_in_precious_metal_stones',
    label: 'Dealers In Precious Metal & Stones (DPMS)',
    dnfi: true
  },
  { value: 'dealers_in_real_estate', label: 'Dealers In Real Estate', dnfi: true },
  { value: 'estate_surveyors_and_valuers', label: 'Estate Surveyors And Valuers', dnfi: true },
  {
    value: 'hotels_and_hospitality_businesses',
    label: 'Hotels And Hospitality Business(Es)',
    dnfi: true
  },
  { value: 'law_firms', label: 'Law Firms', dnfi: true },
  { value: 'mechanized_farming', label: 'Mechanized Farming', dnfi: true },
  { value: 'mortgage_brokers', label: 'Mortgage Brokers', dnfi: true },
  {
    value: 'non_profit_organizations',
    label: 'Non-Profit Organizations (NPOs) (At Risk NPOs)',
    dnfi: true
  },
  { value: 'supermarket', label: 'Supermarket', dnfi: true },
  { value: 'tax_consultants', label: 'Tax Consultants', dnfi: true },
  // Non-DNFI industries
  { value: 'transportation_services', label: 'Transportation Services' },
  { value: 'financial_services', label: 'Financial Services' },
  { value: 'engineering_services', label: 'Engineering Services' },
  { value: 'healthcare_services', label: 'Healthcare Services' },
  { value: 'agriculture_and_food_production', label: 'Agriculture And Food Production' },
  { value: 'manufacturing_industries', label: 'Manufacturing Industries' },
  { value: 'it_and_telecommunications', label: 'IT And Telecommunications' },
  { value: 'general_merchandise', label: 'General Merchandise' },
  {
    value: 'entertainment_and_advertisment_services',
    label: 'Entertainment And Advertisment Services'
  },
  { value: 'household_and_personal_services', label: 'Household And Personal Services' },
  { value: 'energy_and_utilities', label: 'Energy And Utilities' },
  { value: 'general_industry_services', label: 'General Industry Services' },
  { value: 'education_and_training', label: 'Education And Training' },
  { value: 'other', label: 'Others (Please specify)' }
];

const SOURCE_OF_FUNDS_OPTIONS = [
  { value: 'salary', label: 'Salary' },
  { value: 'savings', label: 'Savings' },
  { value: 'business_income', label: 'Business Income' },
  { value: 'inheritance', label: 'Inheritance' },
  { value: 'winnings', label: 'Winnings' },
  { value: 'other', label: 'Other' }
];

const POSITION_STATUS_OPTIONS = [
  { value: 'current', label: 'Current' },
  { value: 'former', label: 'Former' }
];

const ID_FORMAT_RULES = {
  international_passport: {
    regex: /^[A-Z]{1}[0-9]{8}$/,
    placeholder: 'e.g. A12345678',
    message: 'Passport format: 1 uppercase letter followed by 8 digits (e.g. A12345678)'
  },
  drivers_license: {
    regex: /^[A-Z]{3}-[A-Z0-9]{6,12}$/,
    placeholder: 'e.g. ABC-123456',
    message:
      "Driver's license format: 3 uppercase letters, dash, 6–12 alphanumeric characters (e.g. ABC-123456)"
  },
  national_id: {
    regex: /^[0-9]{11}$/,
    placeholder: 'e.g. 12345678901',
    message: 'National ID must be exactly 11 digits (e.g. 12345678901)'
  }
};

/**
 * Validate an ID number against its type's format rules.
 * @param {string} idType - The ID type key (e.g. 'international_passport').
 * @param {string} idNumber - The ID number to validate.
 * @returns {string|null} Error message, or null if valid.
 */
const validateIdNumber = (idType, idNumber) => {
  const rule = ID_FORMAT_RULES[idType];
  if (!rule || !idNumber) return null;
  return rule.regex.test(idNumber.trim()) ? null : rule.message;
};

const AML_MANDATORY_INDUSTRIES = [
  'casinos_pool_betting_lottery_businesses',
  'dealers_in_precious_metal_stones',
  'clearing_forwarding_companies',
  'non_profit_organizations',
  'dealers_in_jewelery',
  'financial_services'
];

const KYB_SAMPLE_DOCS = {
  CERTIFICATE_OF_INCORPORATION: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc1.png',
  PROOF_OF_ADDRESS: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc2.png',
  OPERATING_LICENSE: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc3.png',
  PARTICULARS_OF_DIRECTORS: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc4.png',
  CERTIFIED_SHAREHOLDER_LIST: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc5.png',
  MEANS_OF_ID_UBO: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc6.png',
  AML_POLICY: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc7.png',
  SCUML: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc8.png',
  MEMORANDUM_ARTICLES: 'https://basqet-files-public.s3.us-east-1.amazonaws.com/kyc9.png'
};

export {
  AML_MANDATORY_INDUSTRIES,
  ID_FORMAT_RULES,
  INDUSTRY_OPTIONS,
  KYB_SAMPLE_DOCS,
  POSITION_STATUS_OPTIONS,
  SOURCE_OF_FUNDS_OPTIONS,
  validateIdNumber
};
